import React, { useState, useEffect } from "react";
import "./Galleryupload.css";

const API = "https://backend-ourcountryourpeople-4.onrender.com";

export default function Galleryupload() {
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState("");
  const [status, setStatus] = useState("");
  const [preview, setPreview] = useState(null);
  const [images, setImages] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  // ---------------- FETCH GALLERY ----------------
  const fetchImages = async () => {
    try {
      const res = await fetch(`${API}/api/gallery`);
      const data = await res.json();
      setImages(data || []);
    } catch (err) {
      console.error(err);
      setImages([]);
    }
  };

  useEffect(() => {
    fetchImages();
  }, []);

  // ---------------- IMAGE RESIZE ----------------
  const resizeImage = (file) =>
    new Promise((resolve) => {
      const img = new Image();
      const canvas = document.createElement("canvas");
      const reader = new FileReader();

      reader.onload = (e) => (img.src = e.target.result);

      img.onload = () => {
        const MAX_WIDTH = 900;
        const scale = MAX_WIDTH / img.width;

        canvas.width = MAX_WIDTH;
        canvas.height = img.height * scale;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        canvas.toBlob((blob) => resolve(blob), "image/jpeg", 0.7);
      };

      reader.readAsDataURL(file);
    });

  // ---------------- FILE CHANGE ----------------
  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    setUploading(true);
    const compressed = await resizeImage(selectedFile);

    setFile(compressed);
    setPreview(URL.createObjectURL(compressed));
    setUploading(false);
  };

  // ---------------- UPLOAD ----------------
  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) return setStatus("Please select a photo");

    const formData = new FormData();
    formData.append("photo", file);
    formData.append("title", title);

    try {
      setUploading(true);
      setProgress(0);
      setStatus("");

      const xhr = new XMLHttpRequest();
      xhr.open("POST", `${API}/api/gallery`);

      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) {
          const percent = Math.round((e.loaded * 100) / e.total);
          setProgress(percent);
        }
      };

      xhr.onload = () => {
        if (xhr.status === 200 || xhr.status === 201) {
          setStatus("Uploaded successfully! ✅");
          setFile(null);
          setTitle("");
          setPreview(null);
          fetchImages();
        } else {
          setStatus("Upload failed ❌");
        }
        setUploading(false);
        setProgress(0);
      };

      xhr.onerror = () => {
        setStatus("Server error ❌");
        setUploading(false);
      };

      xhr.send(formData);
    } catch (err) {
      console.error(err);
      setStatus("Upload error");
      setUploading(false);
    }
  };

  return (
    <div className="gallery-container">
      <h2>Upload Gallery Photo</h2>

      <form onSubmit={handleUpload} className="gallery-form">
        <input
          type="text"
          placeholder="Enter title (optional)"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <input type="file" accept="image/*" onChange={handleFileChange} />

        {preview && <img src={preview} alt="preview" className="preview" />}

        <button type="submit" disabled={uploading}>
          {uploading ? "Uploading..." : "Upload"}
        </button>

        {uploading && <p className="upload-progress">Uploading... {progress}%</p>}
        {status && <p className="status">{status}</p>}
      </form>

      {/* ---------------- GALLERY PREVIEW ---------------- */}
      <div className="gallery-preview">
        {images.map((image) => (
          <div key={image._id} className="gallery-item">
            <h4>{image.title}</h4>
            <img src={image.img} alt={image.title} width={200} />
          </div>
        ))}
      </div>
    </div>
  );
}
